// (function () {
//   function px(n) { return `${Math.max(0, Math.round(n))}px`; }

//   function updateStickyVars() {
//     const announcement =
//       document.querySelector('.announcement-bar') ||
//       document.querySelector('[data-section-type*="announcement"]') ||
//       document.querySelector('.announcement-bar__content')?.closest('div');

//     const headerWrap = document.querySelector('.sf-header .header__wrapper');
//     const headerDesktop = document.querySelector('header.sf-header__desktop');
//     const headerMobile = document.querySelector('header.sf-header__mobile');

//     // Measure announcement bar height
//     const aH = announcement ? announcement.getBoundingClientRect().height : 0;

//     // Measure active header height (mobile vs desktop)
//     const activeHeader = window.innerWidth < 1024 ? headerMobile : headerDesktop;
//     const hH = activeHeader ? activeHeader.getBoundingClientRect().height : 0;

//     // Write CSS variables to :root
//     document.documentElement.style.setProperty('--announcement-bar-height', px(aH));
//     document.documentElement.style.setProperty('--sf-header-height', px(hH));
//     document.documentElement.style.setProperty('--sticky-offset', px(aH + hH));

//     // Also set wrapper top directly (this kills the “mystery gap” on mobile)
//     if (headerWrap) {
//       headerWrap.style.top = px(aH);
//     }
//   }

//   // Run early + after everything loads (fonts can change height)
//   document.addEventListener('DOMContentLoaded', updateStickyVars);
//   window.addEventListener('load', updateStickyVars);
//   window.addEventListener('resize', updateStickyVars);

//   // Optional: if announcement text rotates/changes, keep it accurate
//   const obs = new MutationObserver(() => updateStickyVars());
//   obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
// })();


(function () {
  const EXTRA_GAP = 50; // px

  function px(n) {
    return `${Math.max(0, Math.round(n))}px`;
  }

  function findAnnouncementBar() {
    return (
      document.querySelector('.announcement-bar') ||
      document.querySelector('[data-section-type*="announcement"]') ||
      document.querySelector('.announcement-bar__content')?.closest('.announcement-bar') ||
      null
    );
  }

  function updateStickyVars() {
    const announcement = findAnnouncementBar();
    const headerWrap = document.querySelector('.sf-header .header__wrapper') || document.querySelector('.header__wrapper');

    const aH = announcement ? announcement.getBoundingClientRect().height : 0;
    const hH = headerWrap ? headerWrap.getBoundingClientRect().height : 0;

    document.documentElement.style.setProperty('--announcement-bar-height', px(aH));
    document.documentElement.style.setProperty('--sf-header-height', px(hH));
    document.documentElement.style.setProperty('--sticky-offset', px(aH + hH + EXTRA_GAP));

    // Keep header directly under announcement bar (prevents mobile “gap”)
    if (headerWrap) headerWrap.style.top = px(aH);
  }

  // Run early + after load (fonts/images can change heights)
  document.addEventListener('DOMContentLoaded', updateStickyVars);
  window.addEventListener('load', updateStickyVars);
  window.addEventListener('resize', updateStickyVars);
  window.addEventListener('orientationchange', updateStickyVars);

  // Only watch announcement/header changes instead of the entire document (performance)
  const obs = new MutationObserver(() => updateStickyVars());
  const announcement = findAnnouncementBar();
  if (announcement) obs.observe(announcement, { childList: true, subtree: true, characterData: true });
  const headerWrap = document.querySelector('.sf-header .header__wrapper') || document.querySelector('.header__wrapper');
  if (headerWrap) obs.observe(headerWrap, { childList: true, subtree: true, characterData: true });
})();
